import { StatusIconProps, ActivityStatus } from './types'
import { ReactComponent as Maybe } from 'assets/svg/Maybe.svg'
import { ReactComponent as Accepted } from 'assets/svg/Accepted.svg'
import { ReactComponent as Declined } from 'assets/svg/Declined.svg'
import { RespondToTheMeeting } from '../../pages/Calendar/types'

export const StatusIcon = ({ status, children }: StatusIconProps) => {
  if (!status) return <>{children}</>

  return (
    <div className="status-icon-wrapper">
      {children}
      <div className="status-icon">
        {status === RespondToTheMeeting.ACCEPT && <Accepted />}
        {status === RespondToTheMeeting.MAYBE && <Maybe />}
        {status === RespondToTheMeeting.DECLINE && <Declined />}
        {status === ActivityStatus.ACTIVE && (
          <div className="status-icon-circle active" />
        )}
        {status === ActivityStatus.INACTIVE && (
          <div className="status-icon-circle" />
        )}
      </div>
    </div>
  )
}
